import storageService from '@/services/storage';
import productInfoApiDrive from "@/services/http/api-drive/magasin/produit/productInfo";
import panierMapper from "@/services/panier/panier-mapper";
import { useMagasinStore } from '@/store/magasin';
import { usePanierStore } from '@/store/panier';

export default defineNuxtPlugin(async ({ $pinia, $apiDrive }) => {

  const magasinStore = useMagasinStore($pinia);
  const panierStore = usePanierStore($pinia);

  if ((storageService.get("__cora_product_id__") || storageService.get("__cora_abonnement__")) && !magasinStore.isNational) {
    try {
      if (storageService.get("__cora_abonnement__")) {
        const abonnementToAdd = storageService.get("__cora_abonnement__")
        panierStore.syncArticles([panierMapper.getArticleModel(abonnementToAdd)]);
        storageService.delete("__cora_abonnement__");
      } else {
        const article = await $apiDrive.use(productInfoApiDrive).productInfo({ productId: storageService.get("__cora_product_id__"), shopId: magasinStore.id })
        panierStore.syncArticles([panierMapper.getArticleModel(article.data)]);
        storageService.delete("__cora_product_id__");
      }
    } catch (error) {
      $apiDrive.getErrorData(error);
      magasinStore.setDisplayNonExistantProductPopin();
    }
  }
});
